import type { PostApiBranchCreateRequestBody } from "@superblocksteam/schemas";
import type { PostApplicationBranchCreateResponseBody } from "@superblocksteam/shared";

import { callServer, HttpMethod } from "store/utils/client";
import type { ErrorHandlingOptions } from "store/utils/client";

export const createAppBranch = ({
  applicationId,
  name,
  baseBranchName,
  errorHandlingOptions,
}: {
  applicationId: string;
  baseBranchName: string;
  name: string;
  errorHandlingOptions?: ErrorHandlingOptions;
}) => {
  return callServer<PostApplicationBranchCreateResponseBody>(
    {
      method: HttpMethod.Post,
      url: `v2/applications/${applicationId}/branches`,
      body: {
        name,
        baseBranchName,
      },
    },
    errorHandlingOptions,
  );
};

export const createApiBranch = ({
  apiId,
  name,
  baseBranchName,
  errorHandlingOptions,
}: {
  apiId: string;
  name: string;
  baseBranchName: string;
  errorHandlingOptions?: ErrorHandlingOptions;
}) => {
  return callServer<PostApiBranchCreateRequestBody>(
    {
      method: HttpMethod.Post,
      url: `v3/apis/${apiId}/branches`,
      body: {
        name: name,
        baseBranchName,
      },
    },
    errorHandlingOptions,
  );
};
